import { render, staticRenderFns } from "./device_configuration.vue?vue&type=template&id=1f79fa16&scoped=true&"
import script from "./device_configuration.vue?vue&type=script&lang=js&"
export * from "./device_configuration.vue?vue&type=script&lang=js&"
import style0 from "./device_configuration.vue?vue&type=style&index=0&id=1f79fa16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f79fa16",
  null
  
)

/* custom blocks */
import block0 from "./device_configuration.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports